import { produce } from 'immer';
import { CLEAR_TRANSITION_ANIMATION, END_TRANSITION_ANIMATION, START_TRANSITION_ANIMATION } from '../actions/transitionAnimationActions';
const initialState = {};
const transitionAnimationReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_TRANSITION_ANIMATION: {
                if (draft.transition?.type !== 'loading') {
                    // don't interrupt a loading attempt
                    delete draft.transition;
                }
                break;
            }
            case START_TRANSITION_ANIMATION: {
                const { transitionSceneType, transitionAnimationMessage } = action.payload;
                draft.transition = { type: 'loading', transitionSceneType, transitionAnimationMessage };
                break;
            }
            case END_TRANSITION_ANIMATION: {
                if (draft.transition?.type === 'loading') {
                    const { transitionAnimationMessage } = draft.transition; // persist the message from the loading phase
                    draft.transition = { type: 'ending', transitionAnimationMessage };
                }
                break;
            }
        }
    });
};
export default transitionAnimationReducer;
